import { mapState, mapActions } from 'vuex';
import lahiCalculator from './lahi-calculator/lahi-calculator.vue';
import lahiTechnicalError from './lahi-technical-error/lahi-technical-error.vue';
import lahiResult from './lahi-result/lahi-result.vue';
import lahiDiscount from './lahi-common/lahi-discount/lahi-discount.vue';
import lahiEmailForm from './lahi-common/lahi-email-form/lahi-email-form.vue';
import lahiVhk from './lahi-common/lahi-vhk/lahi-vhk.vue';
import getQueryParam from 'get-query-param';
import { selectLoanMixin } from './lahi-common/lahi-mixins/select-lahi-loan-and-open-modal.js';
import VueFeedback from '@ui-common/vue-feedback';
const LOAN_PURPOSE_GET_PARAM = 'hitelCel';
const LAHI_SESSION_COOKIE_NAME = 'LAHI_SESSION';

export default {
	mixins: [selectLoanMixin],
	data() {
		return {
			initTabIndex: 0
		};
	},
	props: {
		lahiVhkModalId: {
			required: true
		},
		ctaText: {
			required: true,
			type: String
		},
		vhkOpenInModal: {
			required: true,
			type: Boolean
		},
		bookmarkId: {
			required: false,
			type: String
		},
		calculatorTabs: {
			required: true,
			type: Array
		},
		calculatorTitle: {},
		swJsonPath: {
			required: true
		},
		layoutCategory: {
			required: true
		},
		requestZipCode: {
			type: Boolean,
			default: false
		},
		formal: {
			default: true
		}
	},
	components: {
		lahiCalculator,
		lahiTechnicalError,
		lahiResult,
		lahiDiscount,
		lahiEmailForm,
		lahiVhk,
		VueFeedback
	},
	watch: {
		calculationInProgress(val) {
			if (val) {
				this.$VueLiveAnnouncer.set('Kérjük várjon, a kalkuláció folyamatban!', { politeness: 'assertive' });
			} else {
				this.$VueLiveAnnouncer.set('A kalkuláció elkészült!', { politeness: 'assertive' });
			}
		}
	},
	methods: {
		...mapActions('lahi', [
			'setLahiVhkId',
			'setCtaText',
			'setVhkOpenInModal',
			'setBookmarkId',
			'setCalculatorTabs',
			'getInitData',
			'calculate',
			'setSessionId',
			'setSwJsonPath',
			'selectLahiLoan',
			'postEmailForm',
			'resetEmailFormStatus',
			'setLayoutCategory'
		])
	},
	computed: {
		...mapState('lahi', [
			'initTechnicalError',
			'sessionId',
			'calculationInProgress',
			'calculationTechnicalError',
			'hasCalculation',
			'selectedLahiProduct',
			'isProductAprDiscounted',
			'sendInEmailTechnicalFailure',
			'sendInEmailSuccess',
			'selectedLahiProductJson',
			'calculationResult'
		]),
		hasProduct() {
			return !!(this.calculationResult && this.calculationResult.products && this.calculationResult.products.length);
		}
	},
	created() {
		let sessionId = this.$cookie.get(LAHI_SESSION_COOKIE_NAME);
		if (sessionId) {
			this.setSessionId(sessionId);
		}
		this.setLahiVhkId(this.lahiVhkModalId);
		this.setCtaText(this.ctaText);
		this.setVhkOpenInModal(this.vhkOpenInModal);
		this.setBookmarkId(this.bookmarkId);
		this.setCalculatorTabs(this.calculatorTabs);
		this.setSwJsonPath(this.swJsonPath);
		this.setLayoutCategory(this.layoutCategory);
		let loanPurposeGetParam = getQueryParam(LOAN_PURPOSE_GET_PARAM, window.location.href);
		let initTabIndex = this.calculatorTabs.findIndex((tabElem) => {
			return tabElem.loanPurpose == loanPurposeGetParam;
		});
		this.initTabIndex = initTabIndex > -1 ? initTabIndex : 0;
	}
};
